import { CityConfigInterface, HaloWidthPayload } from "components/curb/map/deckgl/interfaces";
import { LiveDataInterface } from "../../components/Websockets/types";
import { ResetStateAction } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";

export const TOGGLE_LIVE_DATA = "TOGGLE_LIVE_DATA";
export const UPDATE_LIVE_DATA = "UPDATE_LIVE_DATA";
export const GET_LIVE_DATA = "GET_LIVE_DATA";
export const GET_LAST_UPDATED_LIVE_DATA = "GET_LAST_UPDATED_LIVE_DATA";
export const SET_HALO_WIDTH = "SET_HALO_WIDTH";
export const SET_LAST_UPDATED_LIVE_DATA = "SET_LAST_UPDATED_LIVE_DATA";
export interface LiveDataState {
    liveDataButtonStatus: boolean;
    liveData: LiveDataInterface;
    lastUpdatedLiveData: CityConfigInterface;
}

export interface toggleLiveDataAction {
    type: typeof TOGGLE_LIVE_DATA;
    payload: { isLiveDataOn: boolean };
}

export interface updateLiveDataAction {
    type: typeof UPDATE_LIVE_DATA;
    payload: { data: LiveDataInterface };
}

export interface getLiveDataAction {
    type: typeof GET_LIVE_DATA;
}

export interface getLastUpdatedLiveDataAction {
    type: typeof GET_LAST_UPDATED_LIVE_DATA;
}

export interface setLastUpdatedLiveDataAction {
    type: typeof SET_LAST_UPDATED_LIVE_DATA;
    payload: { data: CityConfigInterface };
}

export interface setHaloWidthAction {
    type: typeof SET_HALO_WIDTH;
    payload: HaloWidthPayload;
}

export type LiveDataTypes =
    | toggleLiveDataAction
    | updateLiveDataAction
    | getLiveDataAction
    | getLastUpdatedLiveDataAction
    | setLastUpdatedLiveDataAction
    | setHaloWidthAction
    | ResetStateAction;
